import type { UserPsi } from "@phurshell/psiapp-frontend-core/domain";
import { defineStore } from "pinia";

export const useSessionStore = defineStore("session", {
  state: (): { session: UserPsi | null } => ({ session: null }),
  persist: true,
  actions: {
    save(params: UserPsi) {
      this.session = params;
    },
    update(params: Partial<UserPsi>) {
      if (this.session) {
        this.session = { ...this.session, ...params };
      }
    },
    destroy() {
      this.session = null;
    },
  },
});
